<template>
  <el-container>
    <template v-if="fullScreen">
      <router-view v-slot="{ Component }">
        <keep-alive>
          <component :is="Component" />
        </keep-alive>
      </router-view>
    </template>

    <template v-else>
      <el-aside
        v-if="showSidebar"
        :style="{
          width: '200px',
          height: '100vh',
          position: 'fixed',
          left: 0,
          top: 0,
          bottom: 0,
          zIndex: 10,
          background: 'rgb(47, 52, 77)',
          'webkit-overflow-scrolling': 'touch',
          overflow: 'auto',
        }"
      >
        <SideMenu />
      </el-aside>
      <el-container
        class="layout-body"
        :style="{
          width: `${showSidebar ? 'calc(100% - 200px)' : '100%'}`,
          height: '100vh',
          marginLeft: `${showSidebar ? '200px' : ''}`,
          background: 'var(--layout-bg)',
        }"
      >
        <el-header
          class="layout-header"
          :style="{
            width: '100%',
            height: '50px',
          }"
        >
          <Navbar />
        </el-header>
        <el-main
          id="main-container"
          class="layout-main"
          :style="{
            width: '100%',
          }"
        >
          <router-view v-slot="{ Component }">
            <keep-alive>
              <component :is="Component" />
            </keep-alive>
          </router-view>
        </el-main>
      </el-container>
    </template>
  </el-container>
</template>

<script setup>
import { ref, computed } from 'vue';
import { storeToRefs } from 'pinia';
import SideMenu from './SideMenu.vue';
import Navbar from './Navbar.vue';
import { rootStore } from '@/store/rootStore';
import { useRoute } from 'vue-router';

const store = rootStore();
const route = useRoute();
const { loginFlag, systemSetting } = storeToRefs(store);

const fullScreen = computed(() => {
  return route.path === '/limithome' || route.path === '/login' || route.path === '/loginV2';
});
const showSidebar = computed(() => {
  return loginFlag.value && !systemSetting.value.hideMenu;
});
</script>

<style lang="less">
.layout-header {
  flex-shrink: 0;
  background: var(--navbar-bg);
  transition: background 0.25s;
}

.layout-body {
  display: flex;
  flex-direction: column;
  overflow: hidden;
}

.layout-main {
  flex: 1;
  min-height: 0;
  overflow: hidden;
  padding: 0 !important;
  box-sizing: border-box;
}

#main-container > * {
  height: 100%;
  min-height: 0;
}

.el-aside::-webkit-scrollbar {
  /*隐藏滚轮*/
  display: none;
}
</style>
